/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React from "react";
import {useFetchServiceModel} from "../../../Hooks/ServiceHooks";
import {service as ProjectService} from "../../../Services/ProjectService";
import {ContextNodeLink} from "../../../Components/Common/ContextNodeLink";

export function ProjectFieldViewer(props) {

	const { Value } = props;

	const project = useFetchServiceModel(ProjectService, Value);

	return <ContextNodeLink contextNodeId={project?.contextNodeId} tool="summary" />;
}
